import { Injectable } from "@angular/core";
import { SyndicateRepositoryService } from "src/app/pages/syndicate/syndicate-repository.service";
import { PaymentService } from "src/app/services/payment.service";
import { SyndicateDataService } from "src/app/services/syndicate-data.service";
import { ModalController } from "@ionic/angular";
import { AuthService } from "@core/auth.service";
import { CatchErrorService } from "@core/catch-error.service";
import { CommonService } from "src/app/services/common/common.service";
import { CelebrationAnimationService } from "@core/celebration-animation.service";
import { Data, Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { AddCardComponent } from "../add-card.component";
import { Location } from '@angular/common'
import { PrivateSyndicateTicketComponent } from "src/app/pages/syndicate/tickets/private-syndicate-ticket/private-syndicate-ticket.component";
import { RegProfileDialogComponentComponent } from "src/app/components/reg-profile-dialog-component/reg-profile-dialog-component.component";
import { filter, map, take } from "rxjs/operators";
import { SyndicateTicketsComponent } from "src/app/pages/syndicate/syndicate-tickets/syndicate-tickets.component";

@Injectable( {
    providedIn: null
})
export class  CheckoutPostPaymentService {
    constructor(
        private paymentService: PaymentService,
        private syndicateService: SyndicateRepositoryService,
        private syndicateDataService: SyndicateDataService,
        private modalController: ModalController,
        private authService: AuthService,
        private catchService: CatchErrorService,
        private commonService: CommonService,
        private celebrationAnimationService: CelebrationAnimationService,
        private router: Router,
        private location: Location,
        private matDialog: MatDialog,
    ) {}

    async viewTicket(ctx: AddCardComponent,page: string) {
        this.paymentService.updatePaymentReqAndRes(ctx.purchaseDetail$?.value, ctx.payment_status).subscribe(
              (sqlAPICall) => {
                ctx.addNewCardInProgress = false;
                ctx.sqlAPICallResponse = sqlAPICall;
                if (sqlAPICall && sqlAPICall?.response && sqlAPICall?.response?.status !== "SUCCESS") {
                  this.authService
                    .getConstantsMsg("1015")
                    .then((translatedMsg) => {
                      const defaultMsg = {
                        message: {
                          line_1: "Something went wrong!",
                          line_2: "",
                        },
                        style: {
                          icon: "tick circle error.svg",
                          type: "Error",
                        },
                      };
                      this.authService.showToastMessage(translatedMsg, defaultMsg);
                    })
                    .catch((err) => {
                      return err;
                    });
        
                  this.location.back();
                  return;
                }
        
                if (page === "topUp") {
                  this.router.navigate(["mainTabs/tabs/store"]);
                  return;
                }
        
                if (page === "syndicate") {
                  this.syndicateService.getPrivateSyndicateProducts(ctx.purchaseDetail$?.value?.psId).subscribe(
                    async (product) => {
                      ctx.addNewCardInProgress = false;
                      const syndicate = ctx.purchaseDetail$?.value;
                      let prdIndex = 0;
                      const syndicateTickets = await this.modalController.create({
                        component: PrivateSyndicateTicketComponent,
                        componentProps: { syndicate, product, prdIndex, source: "syndicateTab" },
                        cssClass: "modal-fullScreen",
                      });
        
                      syndicateTickets
                        .onDidDismiss()
                        .then((res) => {
                          if (res?.data && res?.data?.viewMember) {
                            this.syndicateDataService.setSyndicateID(ctx.purchaseDetail$?.value?.psId);
                            this.router.navigate(["/private-syndicate/syndicate-member/" + ctx.purchaseDetail$?.value?.psId]);
                          }
                          this.router.navigate(["mainTabs/tabs/syndicate"]);
                        })
                        .catch((err) => {
                          return err;
                        });
                      return await syndicateTickets?.present();
                    },
                    (err) => {
                      return err;
                    }
                  );
                  return;
                }
                if (page === "store" && ctx.purchaseDetail$?.value?.prosub_id) {
                  this.router.navigate(["paymentConfirmation"]);
                  return;
                }
              },
              (err) => {
                return err;
              }
            );
      }


    fetchSyndicateAndShowTicket(ctx: AddCardComponent) {
        try {
      // for credit topup case, redirect to store, don't show syndicate ticket
        if (ctx.purchaseDetail$?.value?.isTopUp || ctx.purchaseDetail$?.value?.page === "topUp") {
            this.celebrationAnimationService.setCreditTopupStatus(false);
            this.celebrationAnimationService.trackCelebrations();
            this.router.navigateByUrl("/mainTabs/tabs/store");
            return;
        }
        const sqlAPICall = ctx.sqlAPICallResponse;
        if (sqlAPICall && sqlAPICall?.response?.status === "FAIL") {
            const defaultMsg = {
            message: {
                line_1: sqlAPICall?.response?.message ? sqlAPICall?.response?.message : "Something went wrong.",
                line_2: "",
            },
            style: {
                icon: "tick circle error.svg",
                type: "Error",
            },
            };
            this.authService.showToastMessage({}, defaultMsg);
            this.router.navigate(["mainTabs/tabs/syndicate"]);
            return;
        }

        if (!sqlAPICall || !sqlAPICall?.response) {
            //this.voucherService.setSyndicatePending();
            this.matDialog.open(RegProfileDialogComponentComponent, {
            panelClass: "ongoingWarning-size",
            backdropClass: "ongoingWarning-back-drop-color",
            disableClose: true,
            });
            return;
        }
        if (sqlAPICall && sqlAPICall?.response && sqlAPICall?.response?.syndicate_type == "private") {
            this.paymentService
            .getPrivateSyndicateInfo(sqlAPICall?.response?.encrypt_syndicate_id)
            .subscribe((syndicateData: Data) => {
                const syndicate = syndicateData?.data();
                this.syndicateService.getPrivateSyndicateProducts(syndicate?.sId).subscribe(async (product) => {
                const syndicateTickets = await this.modalController.create({
                    component: PrivateSyndicateTicketComponent,
                    componentProps: { syndicate, product, prdIndex: "0", source: "createPS" },
                    cssClass: "modal-fullScreen",
                    // enterAnimation: CustomAnimation.enterFromRight,
                    // leaveAnimation: CustomAnimation.exitThroughRight,
                });
                syndicateTickets
                    ?.onDidDismiss()
                    .then(() => {
                    setTimeout(() => {
                        this.router.navigateByUrl("/mainTabs/tabs/store");
                    }, 1000);
                    })
                    .catch((err) => {
                    return err;
                    });
                return await syndicateTickets.present();
                });
            });
        } else {
            if (!sqlAPICall || !sqlAPICall?.response) {
            return;
            }
            this.paymentService
            .getSyndicateInfoWithProducts(sqlAPICall?.response?.encrypt_syndicate_id)
            .pipe(
                map((detail: Data) => {
                if (!detail?.[0] || typeof detail[0]?.data !== 'function') return null;
                const syndicateInfo = detail[0].data();
                if (!syndicateInfo) return null;
                syndicateInfo["product"] = [];
                const productDocs = detail && detail?.[1] && detail?.[1].docs ? detail?.[1].docs : "";
                for (let index = 0; index < productDocs?.length; index++) {
                    syndicateInfo?.product?.push(productDocs?.[index]?.data());
                }
                syndicateInfo["cardType"] = "Managed";
                return syndicateInfo;
                }),
                filter((syndicateInfo) => syndicateInfo !== null && syndicateInfo !== undefined)
            )
            .subscribe({
                next: (syndicateInfo) => {
                ctx.addNewCardInProgress = false;
                this.showTicket(syndicateInfo);
                },
                error: (err) => {
                this.catchService.logError('Error fetching syndicate ticket:', err);
                ctx.addNewCardInProgress = false;
                this.authService.getConstantsMsg("1015").then((translatedMsg) => {
                    const defaultMsg = {
                    message: {
                        line_1: "Unable to load ticket. Please check your connection and try again.",
                        line_2: "",
                    },
                    style: {
                        icon: "tick circle error.svg",
                        type: "Error",
                    },
                    };
                    this.authService.showToastMessage(translatedMsg, defaultMsg);
                }).catch((error) => {
                    this.catchService.logError("Error fetching toast message:", error);
                });
                },
                complete: () => {
                // Handle completion when EMPTY is returned (e.g., due to network error)
                if (ctx.addNewCardInProgress) {
                    ctx.addNewCardInProgress = false;
                    this.authService.getConstantsMsg("1015").then((translatedMsg) => {
                    const defaultMsg = {
                        message: {
                        line_1: "Unable to load ticket. Please check your connection and try again.",
                        line_2: "",
                        },
                        style: {
                        icon: "tick circle error.svg",
                        type: "Error",
                        },
                    };
                    this.authService.showToastMessage(translatedMsg, defaultMsg);
                    }).catch((error) => {
                    this.catchService.logError("Error fetching toast message:", error);
                    });
                }
                }
            });
        }
        } catch (e) {
        return e;
        }
      }


    async showTicket(syndicateInfo) {
        const syndicateTickets = await this.modalController.create({
        component: SyndicateTicketsComponent,
        componentProps: { syndicate: syndicateInfo },
        cssClass: "modal-fullScreen",
        });

        syndicateTickets
        ?.onDidDismiss()
        .then(() => {
            setTimeout(() => {
            this.router.navigateByUrl("/mainTabs/tabs/store");
            }, 1000);
        })
        .catch((err) => {
            return err;
        });

        return await syndicateTickets?.present();
    }

    showCreditIssueToast(ctx: AddCardComponent) {
        const awardId = ctx.customOfferAwardId;
        localStorage.removeItem("custom-offer-toast");
        this.commonService.getUid("showCreditIssueToast").pipe(take(1)).subscribe({
        next: (uid: string) => {
            if (!uid || !awardId) return;

            this.authService.customOfferCreditCheck(uid, awardId).subscribe(
            (res) => {
                if (res?.status === "success") {
                this.authService
                    .getConstantsMsg("1114")
                    .then((translatedMsg) => {
                    const defaultMsg = {
                        message: {
                        line_1: "Credit issued to your account",
                        line_2: "",
                        },
                        style: {
                        duration: 2000,
                        icon: "tick circle success.png",
                        type: "Success",
                        },
                    };
                    this.authService?.showToastMessage(translatedMsg, defaultMsg);
                    })
                    .catch((error) => {
                    this.catchService.logError("Error fetching toast message:", error);
                    });
                }
            },
            (err) => {
                this.catchService.logError("Error in customOfferCreditCheck:", err);
            }
            );
        },
        error: (err) => {
            this.catchService.logError("Error fetching UID in showCreditIssueToast:", err);
        },
        });
    }
}
